// Unknown paths used to <Navigate> to the homepage, which left customers following
// an old Squarespace bookmark on a page that never explained itself.

import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { COLORS, FONTS, HEADING } from 'styles/theme';
import { BUTTON } from 'styles/blocks';

const SUGGESTIONS = [
  { label: 'How To Order', to: '/how-to-order' },
  { label: "This Week's Menu", to: '/this-weeks-menu' },
  { label: 'Subscriptions', to: '/prepared-meal-subscription' },
  { label: 'Health Conditions', to: '/health-conditions' },
  { label: 'About Us', to: '/about' },
  { label: 'FAQ', to: '/faqs' },
];

export default function NotFoundPage() {
  const { pathname } = useLocation();

  useEffect(() => { document.title = 'Page Not Found — Square Fare'; }, []);

  return (
    <section style={{
      minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '80px 6vw', background: COLORS.cream,
    }}>
      <p style={{
        fontFamily: FONTS.sans, textTransform: 'uppercase', letterSpacing: '2px',
        fontSize: '13px', fontWeight: 700, color: COLORS.orange, margin: '0 0 14px',
      }}>
        404 — Page Not Found
      </p>

      <h1 style={{ ...HEADING, fontSize: 'clamp(28px, 5vw, 44px)', margin: '0 0 16px' }}>
        We couldn’t find that page
      </h1>

      <p style={{
        fontFamily: FONTS.sans, fontSize: '17px', lineHeight: 1.6,
        color: COLORS.dark, maxWidth: '540px', margin: '0 0 8px',
      }}>
        There’s nothing at <code style={{ fontSize: '15px' }}>{pathname}</code>. We
        recently rebuilt the site, so a saved link or an older search result may point
        somewhere that has since moved.
      </p>

      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: '10px 28px',
        justifyContent: 'center', margin: '28px 0 34px', maxWidth: '620px',
      }}>
        {SUGGESTIONS.map(({ label, to }) => (
          <Link key={to} to={to} style={{
            fontFamily: FONTS.sans, fontSize: '15px', fontWeight: 700,
            textTransform: 'uppercase', letterSpacing: '1.5px',
            color: COLORS.dark, textDecoration: 'underline', textUnderlineOffset: '4px',
          }}>
            {label}
          </Link>
        ))}
      </div>

      <Link to="/" style={BUTTON}>Back to Home</Link>
    </section>
  );
}
